import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const CrownIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faCrown} style={{ color }} />;
};

export default CrownIcon;
